import React, { useEffect, useContext } from 'react'
import { Steps, Divider } from 'antd'
import _ from 'lodash'
import { LoadingOutlined } from '@ant-design/icons'
import { steps } from '../assets/constants'
import { StepContext } from '../utils/StepContext'
const { Step } = Steps

const StepsComponent = (props) => {
  const {
    step: stepValue,
    setStep: setStepValue,
    handleIncrementStep,
    handleDecrementStep
  } = useContext(StepContext)
  useEffect(() => {
    setStepValue(props.draft.masterStep)
  }, [props.draft.masterStep])
  const incrementStep = handleIncrementStep
  const decrementStep = handleDecrementStep
  if (stepValue === undefined) {
    return <LoadingOutlined />
  }
  return (
    <>
      {process.env.REACT_APP_STEPPER_ENABLED === 'true' && (
        <>
          <Steps
            current={stepValue}
            className='site-navigation-steps'
            size='small'
            type='navigation'
          >
            {_.map(steps, (item, index) => (
              <Step
                key={item.title}
                title={item.title}
                onClick={() => setStepValue(index)}
              />
            ))}
          </Steps>
          <Divider />
        </>
      )}
      <div className='steps-content'>
        {steps[stepValue].content({
          goToNextStep: incrementStep,
          goToPreviusStep: decrementStep,
          setMasterStep: setStepValue,
          stepValue,
          draft: props.draft,
          setProgress: props.setProgress
        })}
      </div>
    </>
  )
}

export default StepsComponent
